"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const logisticTripRoutesService = {
  addLogisticTripRoute: function (options) {
    return api.post(`/TripRoutes`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteLogisticTripRoute: function (options) {
    return api.delete(`/TripRoutes`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  updateLogisticTripRouteAlarm: function (options) {
    return api.put(`/TripRoutes/Alarm`, options, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default logisticTripRoutesService;
